export const NAV_SIDE_GET = "nav/side/get";
export const NAV_SIDE_SET = "nav/side/set";
export const NAV_SIDE_TOGGLE = "nav/side/toggle";

export default {
  state: {
    show: false,
  },

  getters: {
    [NAV_SIDE_GET]: ({ show }) => show,
  },

  actions: {
    [NAV_SIDE_TOGGLE]: ({ commit, state }) => {
      commit(NAV_SIDE_SET, !state.show);
    },
  },

  mutations: {
    [NAV_SIDE_SET]: (state, show) => {
      state.show = show;
    },
  },
};
